import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IAnswerLikertModel } from 'models/answerLikert.model'

export const ANSWER_LIKERT_CREATE = 'ANSWER_LIKERT_CREATE'
export const ANSWER_LIKERT_CREATE_SUCCESS = 'ANSWER_LIKERT_CREATE_SUCCESS'
export const ANSWER_LIKERT_EDIT = 'ANSWER_LIKERT_EDIT'
export const ANSWER_LIKERT_EDIT_SUCCESS = 'ANSWER_LIKERT_EDIT_SUCCESS'

export const Actions = {
  answerLikertCreateSuccess: () => createAction(ANSWER_LIKERT_CREATE_SUCCESS),
  answerLikertEditSuccess: (data: IAnswerLikertModel) => createAction(ANSWER_LIKERT_EDIT_SUCCESS, data),
}

export type Actions = ActionsUnion<typeof Actions>
